import React, { useState, useEffect, forwardRef } from "react";
import { useHistory } from "react-router-dom";

import {
  Button,
  Dialog,
  Divider,
  Typography,
  Slide,
  Grid,
  CircularProgress,
  Box,
  TextField,
  MenuItem,
} from "@mui/material";

import { apiGet, API } from "@services/API";
import { useSnackbar } from "notistack";

import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";

import moment from "moment";

// moment.updateLocale("en", {
//   week: {
//     dow: 1,
//   },
// });

const Transition = forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

function headers() {
  let headers = {};
  let token = localStorage.getItem("covid19_token");
  let mfa_token = localStorage.getItem("mfa_token");
  if (token && token.length > 0 && mfa_token && mfa_token.length > 0) {
    headers = { "x-access-token": token };
  }
  return headers;
}

export default function PatientAddEditDialog({
  isVisible,
  onClose,
  onSave,
  patientID,
  wardID,
  hospitalID,
  allWardsRoomData,
  ...props
}) {
  let history = useHistory();
  // console.log("allWardsRoomData ::: ", allWardsRoomData);
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();

  const [loading, setLoading] = useState(true);

  const [dataAdmissionTypes, setDataAdmissionTypes] = useState([]);
  const [dataHospitalsOfOriginsTypes, setDataHospitalsOfOriginsTypes] =
    useState([]);

  const [dataPatient, setDataPatient] = useState({
    facility_id: wardID,
    firstname: "",
    surname: "",
    dob: null,
    gender: "u",
    mrn: "",
    email: "",
    phone: "",
    weight: "",
    hospital_of_origin_id: null,
    address: "",
    note: "",
    past_medical_history: "",
    username: "",
    password: "",
    patient_login_number: 0,

    emergency_name: "",
    emergency_phone: "",
    relationship: "",

    gp_name: "",
    gp_phone: "",
    gp_email: "",
    gp_address: "",

    admission_type: "",
    admission_date: moment(),
    exptected_discharge_date: moment().add(10, "days"),
    observation_times: 4,
    status: 0,
    room_id: "",
    bed_id: "",
    consultant: "",

    discharge_date: null,

    transferred_from: "",
    transfer_history: "",
    diagnosis: "",
    medical_history: "",
    allergies: "",

    observation_id: "",
    resp_rate: "",
    oximeter: "",
    sys: "",
    dia: "",
    hr: "",
    temperature: "",
    news_score: "",

    news_timestamp: null,

    medications_at_discharge: "",
    discharged_plan: "",
    prepared_by_name: "",
    prepared_by_title_position: "",
    is_new_discharge: false,

    admission_rejection: 0,
    admission_decline: "",
    admission_decline_other: "",
    bed_id_reset: null,
  });

  const [isPatientLoadedAsDischarged, setIsPatientLoadedAsDischarged] =
    useState(false);

  useEffect(() => {
    const timeOut = setTimeout(() => {
      if (patientID !== null) {
        apiGet(`/patientDetails/${patientID}`, { headers: headers() }, history)
          .then((response) => {
            const patientDetails = response.data.patientDetails?.[0] || {};
            const patientMostRecentNewsDetails =
              response.data.mostRecentNews?.[0] || {};
            response.data.mostRecentNews[0];

            const patientMostRecentEOC = response.data.mostRecentEOC;

            if (Object.keys(patientDetails).length !== 0) {
              setDataPatient({
                facility_id: patientDetails.facility_id,
                firstname: patientDetails.firstname,
                surname: patientDetails.surname,
                dob: moment(patientDetails.dob, "YYYY-MM-DD"),
                gender: patientDetails.gender,
                mrn: patientDetails.mrn,
                email: patientDetails.email,
                phone: patientDetails.phone,
                weight: patientDetails.weight,
                hospital_of_origin_id: patientDetails.hospital_of_origin_id,
                address: patientDetails.address,
                note: patientDetails.note,
                past_medical_history: patientDetails.past_medical_history,
                username: patientDetails.username,
                password: patientDetails.password,
                patient_login_number: patientDetails.patient_login_number,
                emergency_name: patientDetails.emergency_name,
                emergency_phone: patientDetails.emergency_phone,
                relationship: patientDetails.relationship,
                gp_name: patientDetails.gp_name,
                gp_phone: patientDetails.gp_phone,
                gp_email: patientDetails.gp_email,
                gp_address: patientDetails.gp_address,
                admission_type: patientDetails.admission_type,
                admission_date: moment(
                  patientDetails.timestamp,
                  "YYYY-MM-DD HH:mm:ss"
                ),
                exptected_discharge_date: moment(
                  patientDetails.exptected_discharge_date,
                  "YYYY-MM-DD HH:mm:ss"
                ),
                observation_times:
                  patientDetails.observation_times === 0
                    ? 4
                    : patientDetails.observation_times,
                status: patientDetails.status,
                room_id: patientDetails.room_id,
                bed_id: patientDetails.bed_id,
                consultant: patientDetails.consultant,

                discharge_date: isNullOrEmpty(patientDetails.discharge_date)
                  ? null
                  : moment(
                      patientDetails.discharge_date,
                      "YYYY-MM-DD HH:mm:ss"
                    ),

                transferred_from: !isNullOrEmpty(
                  patientMostRecentEOC.transferred_from
                )
                  ? patientMostRecentEOC.transferred_from
                  : "",
                transfer_history: !isNullOrEmpty(
                  patientMostRecentEOC.transfer_history
                )
                  ? patientMostRecentEOC.transfer_history
                  : "",
                diagnosis: !isNullOrEmpty(patientMostRecentEOC.diagnosis)
                  ? patientMostRecentEOC.diagnosis
                  : "",
                medical_history: !isNullOrEmpty(
                  patientMostRecentEOC.medical_history
                )
                  ? patientMostRecentEOC.medical_history
                  : "",
                allergies: !isNullOrEmpty(patientMostRecentEOC.allergies)
                  ? patientMostRecentEOC.allergies
                  : "",

                observation_id:
                  !isNullOrEmpty(patientMostRecentNewsDetails) &&
                  !isNullOrEmpty(patientMostRecentNewsDetails.observation_id)
                    ? patientMostRecentNewsDetails.observation_id
                    : -1,
                resp_rate:
                  !isNullOrEmpty(patientMostRecentNewsDetails) &&
                  !isNullOrEmpty(patientMostRecentNewsDetails.resp_rate)
                    ? patientMostRecentNewsDetails.resp_rate
                    : "",
                oximeter:
                  !isNullOrEmpty(patientMostRecentNewsDetails) &&
                  !isNullOrEmpty(patientMostRecentNewsDetails.oximeter)
                    ? patientMostRecentNewsDetails.oximeter
                    : "",
                sys:
                  !isNullOrEmpty(patientMostRecentNewsDetails) &&
                  !isNullOrEmpty(patientMostRecentNewsDetails.sys)
                    ? patientMostRecentNewsDetails.sys
                    : "",
                dia:
                  !isNullOrEmpty(patientMostRecentNewsDetails) &&
                  !isNullOrEmpty(patientMostRecentNewsDetails.dia)
                    ? patientMostRecentNewsDetails.dia
                    : "",
                hr:
                  !isNullOrEmpty(patientMostRecentNewsDetails) &&
                  !isNullOrEmpty(patientMostRecentNewsDetails.bpm)
                    ? patientMostRecentNewsDetails.bpm
                    : "",
                temperature:
                  !isNullOrEmpty(patientMostRecentNewsDetails) &&
                  !isNullOrEmpty(patientMostRecentNewsDetails.temperature)
                    ? patientMostRecentNewsDetails.temperature
                    : "",
                news_score: !isNullOrEmpty(patientDetails.news_score)
                  ? patientDetails.news_score
                  : "",

                news_timestamp:
                  patientMostRecentNewsDetails === undefined ||
                  isNullOrEmpty(patientMostRecentNewsDetails.timestamp)
                    ? "never"
                    : moment(
                        patientMostRecentNewsDetails.timestamp,
                        "YYYY-MM-DD HH:mm:ss"
                      ).format("DD/MM/YYYY hh:mm a"),

                medications_at_discharge: !isNullOrEmpty(
                  patientMostRecentEOC.medications_at_discharge
                )
                  ? patientMostRecentEOC.medications_at_discharge
                  : "",
                discharged_plan: !isNullOrEmpty(
                  patientMostRecentEOC.discharged_plan
                )
                  ? patientMostRecentEOC.discharged_plan
                  : "",
                prepared_by_name: !isNullOrEmpty(
                  patientMostRecentEOC.prepared_by_name
                )
                  ? patientMostRecentEOC.prepared_by_name
                  : "",
                prepared_by_title_position: !isNullOrEmpty(
                  patientMostRecentEOC.prepared_by_title_position
                )
                  ? patientMostRecentEOC.prepared_by_title_position
                  : "",

                admission_rejection: !isNullOrEmpty(
                  patientMostRecentEOC.admission_rejection
                )
                  ? patientMostRecentEOC.admission_rejection
                  : 0,
                admission_decline: !isNullOrEmpty(
                  patientMostRecentEOC.admission_decline
                )
                  ? patientMostRecentEOC.admission_decline
                  : "",
                admission_decline_other: !isNullOrEmpty(
                  patientMostRecentEOC.admission_decline_other
                )
                  ? patientMostRecentEOC.admission_decline_other
                  : "",
              });

              setIsPatientLoadedAsDischarged(
                patientDetails.status === 1 ? true : false
              );

              setLoading(false);
            } else {
              setLoading(false);
              console.error("No patient details available");
            }
          })
          .catch((error) => {
            setLoading(false);
          });
      } else {
        setLoading(false);
      }

      apiGet(`/admissiontypes`, { headers: headers() }, history)
        .then((response) => {
          setDataAdmissionTypes(response.data.admissiontypes || []);
        })
        .catch((error) => {
          setDataAdmissionTypes([]);
        });

      apiGet(`/hospitals-of-origin`, { headers: headers() }, history)
        .then((response) => {
          setDataHospitalsOfOriginsTypes(response.data || []);
        })
        .catch((error) => {
          setDataHospitalsOfOriginsTypes([]);
        });
    }, 200);

    return () => clearTimeout(timeOut);
  }, []);

  const showSnackBar = (type, title, subtitle) => {
    const options = { variant: type };

    enqueueSnackbar(
      <div style={{ display: "inline-grid" }}>
        <Typography data-test={"snack-title"} variant="h6">
          {title}
        </Typography>
        <Typography data-test={"snack-text"} variant="subtitle1">
          {subtitle}
        </Typography>
      </div>,
      options
    );
  };

  const isNullOrEmpty = (value) => {
    if (value === null || value === undefined) {
      return true;
    }

    if (typeof value === "string" && value.trim().toLowerCase() === "null") {
      return true;
    }

    if (Array.isArray(value) && value.length === 0) {
      return true;
    }

    if (typeof value === "string" && value.trim() === "") {
      return true;
    }

    if (typeof value === "number" && isNaN(value)) {
      return true;
    }

    return false;
  };

  const isValidEmail = (email) => {
    if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(email)) {
      return true;
    } else {
      return false;
    }
  };

  const handleSave = () => {
    if (isNullOrEmpty(dataPatient.firstname)) {
      showSnackBar("error", "Failure", "Firstname name can't be empty.");
    } else if (isNullOrEmpty(dataPatient.surname)) {
      showSnackBar("error", "Failure", "Surname name can't be empty.");
    } else if (isNullOrEmpty(dataPatient.dob)) {
      showSnackBar("error", "Failure", "D.O.B can't be empty.");
    } else if (isNullOrEmpty(dataPatient.gender)) {
      showSnackBar("error", "Failure", "Gender can't be empty.");
    } else if (isNullOrEmpty(dataPatient.mrn)) {
      showSnackBar("error", "Failure", "MRN can't be empty.");
    } else if (
      !isNullOrEmpty(dataPatient.email) &&
      !isValidEmail(dataPatient.email)
    ) {
      showSnackBar("error", "Failure", "Invalid email address.");
    } else if (isNullOrEmpty(dataPatient.weight)) {
      showSnackBar("error", "Failure", "Weight can't be empty.");
    } else if (isNullOrEmpty(dataPatient.hospital_of_origin_id)) {
      showSnackBar("error", "Failure", "Hospital of origin can't be empty.");
    } else if (isNullOrEmpty(dataPatient.admission_type)) {
      showSnackBar("error", "Failure", "Admission type can't be empty.");
    } else if (isNullOrEmpty(dataPatient.admission_date)) {
      showSnackBar("error", "Failure", "Admission date can't be empty.");
    } else if (isNullOrEmpty(dataPatient.exptected_discharge_date)) {
      showSnackBar("error", "Failure", "EDD can't be empty.");
    } else if (isNullOrEmpty(dataPatient.observation_times)) {
      showSnackBar("error", "Failure", "Observation frequency can't be empty.");
    } else if (isNullOrEmpty(dataPatient.status)) {
      showSnackBar("error", "Failure", "Status can't be empty.");
    } else if (dataPatient.status === 0 && isNullOrEmpty(dataPatient.room_id)) {
      showSnackBar("error", "Failure", "Room name can't be empty.");
    } else if (dataPatient.status === 0 && isNullOrEmpty(dataPatient.bed_id)) {
      showSnackBar("error", "Failure", "Bed name can't be empty.");
    } else if (
      dataPatient.status === 1 &&
      isNullOrEmpty(dataPatient.discharge_date)
    ) {
      showSnackBar("error", "Failure", "Discharge date can't be empty.");
    } else if (
      dataPatient.status === 1 &&
      isNullOrEmpty(dataPatient.transferred_from)
    ) {
      showSnackBar("error", "Failure", "Transferred from can't be empty.");
    } else if (
      dataPatient.status === 1 &&
      isNullOrEmpty(dataPatient.transfer_history)
    ) {
      showSnackBar("error", "Failure", "Transfer history can't be empty.");
    } else if (
      dataPatient.status === 1 &&
      isNullOrEmpty(dataPatient.diagnosis)
    ) {
      showSnackBar("error", "Failure", "Diagnosis can't be empty.");
    } else if (
      dataPatient.status === 1 &&
      isNullOrEmpty(dataPatient.medical_history)
    ) {
      showSnackBar("error", "Failure", "Medical history can't be empty.");
    } else if (
      dataPatient.status === 1 &&
      isNullOrEmpty(dataPatient.allergies)
    ) {
      showSnackBar("error", "Failure", "Allergies can't be empty.");
    } else if (
      dataPatient.status === 1 &&
      isNullOrEmpty(dataPatient.medications_at_discharge)
    ) {
      showSnackBar(
        "error",
        "Failure",
        "Medications at discharge can't be empty."
      );
    } else if (
      dataPatient.status === 1 &&
      isNullOrEmpty(dataPatient.discharged_plan)
    ) {
      showSnackBar("error", "Failure", "Discharged plan can't be empty.");
    } else if (
      dataPatient.status === 1 &&
      isNullOrEmpty(dataPatient.prepared_by_name)
    ) {
      showSnackBar("error", "Failure", "Prepared by name can't be empty.");
    } else if (
      dataPatient.status === 1 &&
      isNullOrEmpty(dataPatient.prepared_by_title_position)
    ) {
      showSnackBar(
        "error",
        "Failure",
        "Prepared by title/position can't be empty."
      );
    } else if (
      dataPatient.admission_rejection === 1 &&
      isNullOrEmpty(dataPatient.admission_decline)
    ) {
      showSnackBar("error", "Failure", "Admission decline can't be empty.");
    } else if (
      dataPatient.admission_rejection === 1 &&
      !isNullOrEmpty(dataPatient.admission_decline) &&
      dataPatient.admission_decline === "Other" &&
      isNullOrEmpty(dataPatient.admission_decline_other)
    ) {
      showSnackBar(
        "error",
        "Failure",
        "Admission decline other can't be empty."
      );
    } else {
      if (!isPatientLoadedAsDischarged && dataPatient.status === 1) {
        const message = {
          user_id: Number(localStorage.getItem("user_id")),
          patient_id: patientID,
          facility_id: wardID,
          firstname: dataPatient.firstname,
          surname: dataPatient.surname,
          dob: moment(dataPatient.dob).format("YYYY-MM-DD HH:mm:ss"),
          mrn: dataPatient.mrn,
          hospital_of_origin_id: Number(dataPatient.hospital_of_origin_id),
          admission_date: moment(dataPatient.admission_date).format(
            "YYYY-MM-DD HH:mm:ss"
          ),
          discharge_date: moment(dataPatient.discharge_date).format(
            "YYYY-MM-DD HH:mm:ss"
          ),
          transferred_from: dataPatient.transferred_from,
          transfer_history: dataPatient.transfer_history,
          diagnosis: dataPatient.diagnosis,
          medical_history: dataPatient.medical_history,
          allergies: dataPatient.allergies,

          observation_id: dataPatient.observation_id,
          resp_rate: dataPatient.resp_rate,
          oximeter: dataPatient.oximeter,
          sys: dataPatient.sys,
          dia: dataPatient.dia,
          hr: dataPatient.hr,
          temperature: dataPatient.temperature,
          news_score: dataPatient.news_score,

          medications_at_discharge: dataPatient.medications_at_discharge,
          discharged_plan: dataPatient.discharged_plan,
          prepared_by_name: dataPatient.prepared_by_name,
          prepared_by_title_position: dataPatient.prepared_by_title_position,

          admission_rejection: dataPatient.admission_rejection,
          admission_decline: dataPatient.admission_decline,
          admission_decline_other: dataPatient.admission_decline_other,

          status: 1,
        };

        API.post(`patients/discharge/${patientID}`, message, {
          headers: headers(),
        })
          .then((response) => {
            showSnackBar(
              "success",
              "Success",
              "Successfully discharged patient."
            );

            onSave();
          })
          .catch((error) => {
            showSnackBar("error", "Failure", "Failed to discharge patient.");
          });
      } else {
        const message = {
          admin_user_id: Number(localStorage.getItem("user_id")),
          admin_facility_id: Number(localStorage.getItem("user_facility_id")),
          facility: dataPatient.facility_id,
          facility_id: dataPatient.facility_id,
          hospital_id: hospitalID,
          patient_id: patientID,
          mrn: dataPatient.mrn,
          uid: "",
          firstname: dataPatient.firstname,
          surname: dataPatient.surname,
          dob: moment(dataPatient.dob).format("YYYY-MM-DD"),
          gender: dataPatient.gender,
          address: dataPatient.address,
          phone: dataPatient.phone,
          note: dataPatient.note,
          past_medical_history: dataPatient.past_medical_history,
          emergency_name: dataPatient.emergency_name,
          emergency_phone: dataPatient.emergency_phone,
          email: dataPatient.email,
          status: dataPatient.status,
          exptected_discharge_date: moment(dataPatient.exptected_discharge_date)
            .startOf("day")
            .format("YYYY-MM-DD HH:mm:ss"),
          observation_times: dataPatient.observation_times,
          patient_login_number: isNullOrEmpty(dataPatient.patient_login_number)
            ? 0
            : dataPatient.patient_login_number,
          timestamp: moment(dataPatient.admission_date).format(
            "YYYY-MM-DD HH:mm:ss"
          ),
          weight: dataPatient.weight,
          hospital_of_origin_id: Number(dataPatient.hospital_of_origin_id),
          relationship: dataPatient.relationship,
          room_id: dataPatient.room_id,
          bed_id: dataPatient.bed_id,
          admission_type: dataPatient.admission_type,
          gp_name: dataPatient.gp_name,
          gp_address: dataPatient.gp_address,
          gp_phone: dataPatient.gp_phone,
          gp_email: dataPatient.gp_email,
          consultant: dataPatient.consultant,

          admission_date: moment(dataPatient.admission_date).format(
            "YYYY-MM-DD HH:mm:ss"
          ),

          username: dataPatient.username,
          password: dataPatient.password,

          discharge_date: !isNullOrEmpty(dataPatient.discharge_date)
            ? moment(dataPatient.discharge_date).format("YYYY-MM-DD HH:mm:ss")
            : null,
        };

        API.post("/patient", message, {
          headers: headers(),
        })
          .then((response) => {
            showSnackBar(
              "success",
              "Success",
              "Successfully saved patient details."
            );

            onSave();
          })
          .catch((error) => {
            if (error.response.data.message === "MRN already used.") {
              showSnackBar(
                "error",
                "Failure",
                "Change MRN as the entered one is already been used by another user."
              );
            } else {
              showSnackBar(
                "error",
                "Failure",
                "Failed to save patient details."
              );
            }
          });
      }
    }
  };

  const handleClose = () => {
    onClose();
  };

  console.log("got this far:::");
  return (
    <Dialog
      fullWidth={true}
      maxWidth="xl"
      //fullScreen
      open={isVisible}
      onClose={handleClose}
      TransitionComponent={Transition}
      PaperProps={{
        style: {
          backgroundColor: "#FFF",
          boxShadow: "none",
        },
      }}
    >
      <Box
        style={{
          display: "flex",
          justifyContent: "center",
          margin: 15,
        }}
      >
        {loading ? (
          <CircularProgress data-test={"loading-indicator"} color="primary" />
        ) : (
          <>
            <Grid
              container
              spacing={2}
              style={{ display: "flex", alignItems: "center" }}
            >
              <Grid
                item
                xs={12}
                md={12}
                style={{
                  display: "flex",
                  justifyContent: "center",
                }}
              >
                <Typography data-test={"patient-add-edit-title"} variant="h6">
                  Patient Details
                </Typography>
              </Grid>
              <Grid item xs={12}>
                <Typography
                  data-test={"patient-add-edit-personal-details-title"}
                  variant="subtitle2"
                >
                  Patient Personal Details
                </Typography>
                <Divider />
              </Grid>
              <Grid item xs={12} md={3}>
                <TextField
                  data-test={"patient-add-edit-firstname"}
                  fullWidth
                  required
                  label="Firstname"
                  size="small"
                  value={dataPatient.firstname || ""}
                  onChange={(e) =>
                    setDataPatient({
                      ...dataPatient,
                      firstname: e.target.value,
                    })
                  }
                />
              </Grid>
              <Grid item xs={12} md={3}>
                <TextField
                  data-test={"patient-add-edit-surname"}
                  id="surname"
                  fullWidth
                  required
                  label="Surname"
                  size="small"
                  value={dataPatient.surname || ""}
                  onChange={(e) =>
                    setDataPatient({ ...dataPatient, surname: e.target.value })
                  }
                />
              </Grid>
              <Grid item xs={12} md={3}>
                <LocalizationProvider dateAdapter={AdapterMoment}>
                  <DatePicker
                    //data-test={"patient-add-edit-dob"}
                    label="D.O.B"
                    slotProps={{
                      textField: {
                        fullWidth: true,
                        required: true,
                        variant: "outlined",
                        size: "small",
                        "data-test": "patient-add-edit-dob",
                      },
                    }}
                    format="DD/MM/YYYY"
                    dayOfWeekFormatter={(day) => `${day}`}
                    value={
                      !isNullOrEmpty(dataPatient.dob) ? dataPatient.dob : null
                    }
                    onChange={(date) =>
                      setDataPatient({
                        ...dataPatient,
                        dob: date,
                      })
                    }
                  />
                </LocalizationProvider>
              </Grid>
              <Grid item xs={12} md={3}>
                <TextField
                  data-test={"patient-add-edit-gender"}
                  select
                  fullWidth
                  required
                  label="Gender"
                  size="small"
                  value={dataPatient.gender || "u"}
                  onChange={(e) =>
                    setDataPatient({ ...dataPatient, gender: e.target.value })
                  }
                >
                  <MenuItem value="m">Male</MenuItem>
                  <MenuItem value="f">Female</MenuItem>
                  <MenuItem value="u">Unknown</MenuItem>
                </TextField>
              </Grid>
              <Grid item xs={12} md={2}>
                <TextField
                  data-test={"patient-add-edit-mrn"}
                  fullWidth
                  required
                  label="MRN"
                  size="small"
                  value={dataPatient.mrn || ""}
                  onChange={(e) =>
                    setDataPatient({ ...dataPatient, mrn: e.target.value })
                  }
                />
              </Grid>
              <Grid item xs={12} md={3}>
                <TextField
                  data-test={"patient-add-edit-email"}
                  fullWidth
                  label="Email"
                  size="small"
                  value={dataPatient.email || ""}
                  onChange={(e) =>
                    setDataPatient({ ...dataPatient, email: e.target.value })
                  }
                />
              </Grid>
              <Grid item xs={12} md={2}>
                <TextField
                  data-test={"patient-add-edit-phone"}
                  fullWidth
                  label="Phone"
                  size="small"
                  value={dataPatient.phone || ""}
                  onChange={(e) =>
                    setDataPatient({
                      ...dataPatient,
                      phone: e.target.value,
                    })
                  }
                />
              </Grid>
              <Grid item xs={12} md={2}>
                <TextField
                  data-test={"patient-add-edit-weight"}
                  fullWidth
                  required
                  label="Weight"
                  size="small"
                  value={dataPatient.weight || ""}
                  onChange={(e) => {
                    const inputValue = e.target.value;
                    if (
                      inputValue === "" ||
                      (!isNaN(inputValue) && parseFloat(inputValue) >= 0)
                    ) {
                      setDataPatient({ ...dataPatient, weight: inputValue });
                    } else {
                      showSnackBar("error", "Failure", "Invalid weight value.");
                    }
                  }}
                />
              </Grid>
              <Grid item xs={12} md={3}>
                <TextField
                  data-test={"patient-add-edit-hospital-of-origin"}
                  select
                  fullWidth
                  required
                  label="Hospital Of Origin"
                  size="small"
                  value={dataPatient.hospital_of_origin_id || ""}
                  onChange={(e) =>
                    setDataPatient({
                      ...dataPatient,
                      hospital_of_origin_id: Number(e.target.value),
                    })
                  }
                >
                  {dataHospitalsOfOriginsTypes.length > 0 ? (
                    dataHospitalsOfOriginsTypes.map((item) => (
                      <MenuItem
                        key={item.hospital_of_origin_id}
                        value={item.hospital_of_origin_id}
                      >
                        {item.name}
                      </MenuItem>
                    ))
                  ) : (
                    <MenuItem disabled>No Hospitals Available</MenuItem>
                  )}
                </TextField>
              </Grid>
              <Grid item xs={12} md={6}>
                <TextField
                  data-test={"patient-add-edit-address"}
                  fullWidth
                  label="Address"
                  size="small"
                  value={dataPatient.address || ""}
                  onChange={(e) =>
                    setDataPatient({ ...dataPatient, address: e.target.value })
                  }
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <TextField
                  data-test={"patient-add-edit-note"}
                  fullWidth
                  label="Note"
                  size="small"
                  value={dataPatient.note || ""}
                  onChange={(e) =>
                    setDataPatient({ ...dataPatient, note: e.target.value })
                  }
                />
              </Grid>
              <Grid item xs={12} md={12}>
                <TextField
                  data-test={"patient-add-edit-past-medical-history"}
                  fullWidth
                  label="Past Medical History"
                  size="small"
                  multiline
                  rows={1}
                  value={dataPatient.past_medical_history}
                  onChange={(e) =>
                    setDataPatient({
                      ...dataPatient,
                      past_medical_history: e.target.value,
                    })
                  }
                />
              </Grid>
              <Grid item xs={12} style={{ paddingTop: 25 }}>
                <Typography
                  data-test={"patient-add-edit-login-details-title"}
                  variant="subtitle2"
                >
                  Patient Login Details
                </Typography>
                <Divider />
              </Grid>
              <Grid item xs={12} md={4}>
                <TextField
                  data-test={"patient-add-edit-username"}
                  fullWidth
                  label="Username"
                  size="small"
                  value={dataPatient.username || ""}
                  onChange={(e) =>
                    setDataPatient({ ...dataPatient, username: e.target.value })
                  }
                />
              </Grid>
              <Grid item xs={12} md={4}>
                <TextField
                  data-test={"patient-add-edit-password"}
                  fullWidth
                  label="Password"
                  size="small"
                  value={dataPatient.password || ""}
                  onChange={(e) =>
                    setDataPatient({ ...dataPatient, password: e.target.value })
                  }
                />
              </Grid>
              <Grid item xs={12} md={4}>
                <TextField
                  data-test={"patient-add-edit-patient-login"}
                  fullWidth
                  label="Patient Login"
                  size="small"
                  value={dataPatient.patient_login_number || ""}
                  onChange={(e) => {
                    const inputValue = e.target.value;
                    if (
                      inputValue === "" ||
                      (!isNaN(inputValue) && parseFloat(inputValue) >= 0)
                    ) {
                      setDataPatient({
                        ...dataPatient,
                        patient_login_number: inputValue,
                      });
                    } else {
                      showSnackBar(
                        "error",
                        "Failure",
                        "Invalid login number value."
                      );
                    }
                  }}
                />
              </Grid>
              <Grid item xs={12} style={{ paddingTop: 25 }}>
                <Typography
                  data-test={"patient-add-edit-emergency-contact-title"}
                  variant="subtitle2"
                >
                  Patient Emergency Contact
                </Typography>
                <Divider />
              </Grid>
              <Grid item xs={12} md={4}>
                <TextField
                  data-test={"patient-add-edit-emergency-contact-name"}
                  fullWidth
                  label="Emergency Contact Name"
                  size="small"
                  value={dataPatient.emergency_name || ""}
                  onChange={(e) =>
                    setDataPatient({
                      ...dataPatient,
                      emergency_name: e.target.value,
                    })
                  }
                />
              </Grid>
              <Grid item xs={12} md={4}>
                <TextField
                  data-test={"patient-add-edit-emergency-contact-phone"}
                  fullWidth
                  label="Emergency Contact Phone"
                  size="small"
                  value={dataPatient.emergency_phone || ""}
                  onChange={(e) =>
                    setDataPatient({
                      ...dataPatient,
                      emergency_phone: e.target.value,
                    })
                  }
                />
              </Grid>
              <Grid item xs={12} md={4}>
                <TextField
                  data-test={"patient-add-edit-emergency-contact-relationship"}
                  fullWidth
                  label="Emergency Contact Relationship"
                  size="small"
                  value={dataPatient.relationship || ""}
                  onChange={(e) =>
                    setDataPatient({
                      ...dataPatient,
                      relationship: e.target.value,
                    })
                  }
                />
              </Grid>
              <Grid item xs={12} style={{ paddingTop: 25 }}>
                <Typography
                  data-test={"patient-add-edit-gp-details-title"}
                  variant="subtitle2"
                >
                  Patient GP Details
                </Typography>
                <Divider />
              </Grid>
              <Grid item xs={12} md={3}>
                <TextField
                  data-test={"patient-add-edit-gp-name"}
                  fullWidth
                  label="GP Name"
                  size="small"
                  value={dataPatient.gp_name}
                  onChange={(e) =>
                    setDataPatient({ ...dataPatient, gp_name: e.target.value })
                  }
                />
              </Grid>
              <Grid item xs={12} md={3}>
                <TextField
                  data-test={"patient-add-edit-gp-phone"}
                  fullWidth
                  label="GP Phone"
                  size="small"
                  value={dataPatient.gp_phone}
                  onChange={(e) =>
                    setDataPatient({
                      ...dataPatient,
                      gp_phone: e.target.value,
                    })
                  }
                />
              </Grid>
              <Grid item xs={12} md={3}>
                <TextField
                  data-test={"patient-add-edit-gp-email"}
                  fullWidth
                  label="GP Email"
                  size="small"
                  value={dataPatient.gp_email}
                  onChange={(e) =>
                    setDataPatient({ ...dataPatient, gp_email: e.target.value })
                  }
                />
              </Grid>
              <Grid item xs={12} md={3}>
                <TextField
                  data-test={"patient-add-edit-gp-address"}
                  fullWidth
                  label="GP Address"
                  size="small"
                  value={dataPatient.gp_address}
                  onChange={(e) =>
                    setDataPatient({
                      ...dataPatient,
                      gp_address: e.target.value,
                    })
                  }
                />
              </Grid>
              <Grid item xs={12} md={12}>
                <Button
                  data-test={"patient-add-edit-find-gp-btn"}
                  variant="contained"
                  color="primary"
                  size="small"
                  onClick={() => {
                    window.open(
                      "https://www.icgp.ie/go/find_a_gp",
                      "_blank",
                      "noreferrer"
                    );
                  }}
                >
                  Find GP
                </Button>
              </Grid>
              <Grid item xs={12} style={{ paddingTop: 25 }}>
                <Typography
                  data-test={"patient-add-edit-care-plan-title"}
                  variant="subtitle2"
                >
                  Patient Care Plan
                </Typography>
                <Divider />
              </Grid>
              <Grid item xs={12} md={3}>
                <TextField
                  data-test={"patient-add-edit-admission-type"}
                  select
                  fullWidth
                  required
                  label="Admission Type"
                  size="small"
                  value={dataPatient.admission_type || ""}
                  onChange={(e) => {
                    setDataPatient({
                      ...dataPatient,
                      admission_type: e.target.value,
                      status: 2,
                      facility: 999999,
                      facility_id: 999999,
                    });
                  }}
                >
                  {dataAdmissionTypes.length > 0 ? (
                    dataAdmissionTypes.map((type) => (
                      <MenuItem key={type.id} value={type.id}>
                        {type.admission_type}
                      </MenuItem>
                    ))
                  ) : (
                    <MenuItem disabled>No Admission Types Available</MenuItem>
                  )}
                </TextField>{" "}
              </Grid>
              <Grid item xs={12} md={3}>
                <LocalizationProvider dateAdapter={AdapterMoment}>
                  <DatePicker
                    id="AdmissionDatePicker1"
                    label={
                      dataPatient.admission_type === 1
                        ? "Scheduled Admission Date"
                        : "Admission Date"
                    }
                    slotProps={{
                      textField: {
                        fullWidth: true,
                        required: true,
                        variant: "outlined",
                        size: "small",
                        // disabled: patientID !== null,
                        "data-test": "patient-add-edit-admission-date",
                      },
                    }}
                    // disabled={patientID !== null}
                    format="DD/MM/YYYY"
                    dayOfWeekFormatter={(day) => `${day}`}
                    value={
                      !isNullOrEmpty(dataPatient.admission_date)
                        ? dataPatient.admission_date
                        : null
                    }
                    onChange={(date) => {
                      if (
                        moment(date).isBefore(
                          moment(dataPatient.exptected_discharge_date)
                        )
                      ) {
                        setDataPatient({
                          ...dataPatient,
                          admission_date: date,
                        });
                      } else {
                        showSnackBar(
                          "error",
                          "Failure",
                          "Admission date can't be after EDD."
                        );
                      }
                    }}
                  />
                </LocalizationProvider>
              </Grid>
              <Grid item xs={12} md={3}>
                <LocalizationProvider dateAdapter={AdapterMoment}>
                  <DatePicker
                    label="EDD"
                    slotProps={{
                      textField: {
                        fullWidth: true,
                        required: true,
                        variant: "outlined",
                        size: "small",
                        "data-test": "patient-add-edit-edd",
                      },
                    }}
                    format="DD/MM/YYYY"
                    dayOfWeekFormatter={(day) => `${day}`}
                    value={
                      !isNullOrEmpty(dataPatient.exptected_discharge_date)
                        ? dataPatient.exptected_discharge_date
                        : null
                    }
                    onChange={(date) => {
                      if (
                        moment(date).isAfter(moment(dataPatient.admission_date))
                      ) {
                        setDataPatient({
                          ...dataPatient,
                          exptected_discharge_date: date,
                        });
                      } else {
                        showSnackBar(
                          "error",
                          "Failure",
                          "EDD can't be before admission date."
                        );
                      }
                    }}
                  />
                </LocalizationProvider>
              </Grid>
              <Grid item xs={12} md={3}>
                <TextField
                  data-test={"patient-add-edit-observation-frequency"}
                  select
                  fullWidth
                  required
                  label="Observation Frequency"
                  size="small"
                  value={dataPatient.observation_times}
                  disabled={dataPatient.admission_type === 1}
                  onChange={(e) =>
                    setDataPatient({
                      ...dataPatient,
                      observation_times: e.target.value,
                    })
                  }
                >
                  <MenuItem value="1">Once per Day (every 24 hrs)</MenuItem>
                  <MenuItem value="2">Twice per Day (every 12 hrs)</MenuItem>
                  <MenuItem value="3">
                    Three times per Day (every 8 hrs)
                  </MenuItem>
                  <MenuItem value="4">
                    Four times per Day (every 6 hrs)
                  </MenuItem>
                </TextField>
              </Grid>
              <Grid item xs={12} md={2}>
                {dataPatient.admission_type === 1 ? (
                  <TextField
                    data-test="patient-add-edit-status"
                    select
                    fullWidth
                    required
                    disabled={true}
                    label="Status"
                    size="small"
                    value={dataPatient.status || ""}
                    onChange={(e) =>
                      setDataPatient({
                        ...dataPatient,
                        status: Number(e.target.value),
                      })
                    }
                  >
                    <MenuItem key={0} value={0}>
                      Active
                    </MenuItem>
                    <MenuItem key={1} value={1}>
                      Discharged
                    </MenuItem>
                    <MenuItem key={2} value={2}>
                      Scheduled
                    </MenuItem>
                  </TextField>
                ) : (
                  <TextField
                    data-test="patient-add-edit-status"
                    select
                    fullWidth
                    required
                    label="Status"
                    size="small"
                    value={dataPatient.status}
                    onChange={(e) =>
                      setDataPatient({
                        ...dataPatient,
                        status: Number(e.target.value),
                      })
                    }
                  >
                    <MenuItem key={0} value={0}>
                      Active
                    </MenuItem>
                    <MenuItem key={1} value={1}>
                      Discharged
                    </MenuItem>
                    <MenuItem key={2} value={2}>
                      Scheduled
                    </MenuItem>
                  </TextField>
                )}
              </Grid>

              <Grid item xs={12} md={3}>
                <TextField
                  data-test={"patient-add-edit-ward-name"}
                  select
                  fullWidth
                  required={dataPatient.status === 0}
                  label="Ward Name"
                  size="small"
                  disabled={
                    dataPatient.status === 1 || dataPatient.admission_type === 1
                  }
                  value={dataPatient.facility_id || 0}
                  onChange={(e) =>
                    setDataPatient({
                      ...dataPatient,
                      facility_id: e.target.value,
                      room_id: null,
                      bed_id: null,
                    })
                  }
                >
                  {allWardsRoomData?.length > 0 ? (
                    allWardsRoomData.map((item) => (
                      <MenuItem key={item.facility_id} value={item.facility_id}>
                        {item.facility}
                      </MenuItem>
                    ))
                  ) : (
                    <MenuItem disabled>No wards available</MenuItem>
                  )}
                </TextField>
              </Grid>

              <Grid item xs={12} md={2}>
                <TextField
                  data-test={"patient-add-edit-room-name"}
                  select
                  fullWidth
                  required={dataPatient.status === 0}
                  label="Room Name"
                  size="small"
                  disabled={
                    dataPatient.status === 1 ||
                    dataPatient.facility_id === null ||
                    dataPatient.admission_type === 1
                  }
                  value={dataPatient.room_id || ""}
                  onChange={(e) =>
                    setDataPatient({
                      ...dataPatient,
                      room_id: e.target.value,
                    })
                  }
                >
                  {dataPatient.facility_id &&
                  allWardsRoomData?.find(
                    (ward) => ward.facility_id === dataPatient.facility_id
                  )?.room_data?.length > 0 ? (
                    allWardsRoomData
                      .find(
                        (ward) => ward.facility_id === dataPatient.facility_id
                      )
                      ?.room_data.map((room) => (
                        <MenuItem key={room.id} value={room.id}>
                          {"Room name: " +
                            room.name +
                            " Gender: " +
                            room.gender}
                        </MenuItem>
                      ))
                  ) : (
                    <MenuItem disabled>No rooms available</MenuItem>
                  )}
                </TextField>
              </Grid>
              <Grid item xs={12} md={2}>
                <TextField
                  data-test={"patient-add-edit-bed-name"}
                  select
                  fullWidth
                  required={dataPatient.status === 0}
                  label="Bed Name"
                  size="small"
                  disabled={
                    dataPatient.room_id === undefined ||
                    dataPatient.room_id === null ||
                    dataPatient.room_id === "" ||
                    dataPatient.facility_id === null ||
                    dataPatient.status === 1 ||
                    dataPatient.admission_type === 1
                  }
                  value={dataPatient.bed_id || ""}
                  onChange={(e) =>
                    setDataPatient({
                      ...dataPatient,
                      bed_id: e.target.value,
                    })
                  }
                >
                  {dataPatient.room_id &&
                  allWardsRoomData
                    ?.find(
                      (ward) => ward.facility_id === dataPatient.facility_id
                    )
                    ?.room_data.find((room) => room.id === dataPatient.room_id)
                    ?.beds?.filter(
                      (bed) =>
                        bed.patient_id === null ||
                        bed.bed_id === dataPatient.bed_id
                    ).length > 0 ? (
                    allWardsRoomData
                      .find(
                        (ward) => ward.facility_id === dataPatient.facility_id
                      )
                      .room_data.find((room) => room.id === dataPatient.room_id)
                      .beds.filter(
                        (bed) =>
                          bed.patient_id === null ||
                          bed.bed_id === dataPatient.bed_id
                      )
                      .map((bed) => (
                        <MenuItem key={bed.bed_id} value={bed.bed_id}>
                          {bed.name}
                        </MenuItem>
                      ))
                  ) : (
                    <MenuItem disabled value="">
                      No available beds in this room
                    </MenuItem>
                  )}
                </TextField>
              </Grid>
              <Grid item xs={12} md={3}>
                <TextField
                  data-test={"patient-add-edit-consultant-name"}
                  fullWidth
                  label="Consultant"
                  size="small"
                  value={dataPatient.consultant || ""}
                  onChange={(e) =>
                    setDataPatient({
                      ...dataPatient,
                      consultant: e.target.value,
                    })
                  }
                />
              </Grid>
              {dataPatient.status === 1 && (
                <>
                  <Grid
                    item
                    xs={12}
                    md={12}
                    style={{
                      display: "flex",
                      justifyContent: "center",
                    }}
                  >
                    <Typography
                      data-test={"patient-add-edit-discharge-details-title"}
                      variant="h6"
                    >
                      Discharge Details
                    </Typography>
                  </Grid>

                  <Grid item xs={12} md={6}>
                    <TextField
                      data-test={"patient-add-edit-discharge-transferred-from"}
                      fullWidth
                      required
                      label="Transferred From"
                      size="small"
                      disabled={isPatientLoadedAsDischarged}
                      value={
                        dataPatient.transferred_from
                          ? dataPatient.transferred_from
                          : ""
                      }
                      onChange={(e) =>
                        setDataPatient({
                          ...dataPatient,
                          transferred_from: e.target.value,
                        })
                      }
                    />
                  </Grid>

                  <Grid item xs={12} md={6}>
                    <TextField
                      data-test={"patient-add-edit-discharge-discharged-plan"}
                      fullWidth
                      required
                      label="Discharge Plan"
                      size="small"
                      disabled={isPatientLoadedAsDischarged}
                      value={
                        dataPatient.discharged_plan
                          ? dataPatient.discharged_plan
                          : ""
                      }
                      onChange={(e) =>
                        setDataPatient({
                          ...dataPatient,
                          discharged_plan: e.target.value,
                        })
                      }
                    />
                  </Grid>

                  <Grid item xs={12} md={6}>
                    <TextField
                      data-test={"patient-add-edit-discharge-diagnosis"}
                      fullWidth
                      required
                      label="Diagnosis"
                      size="small"
                      disabled={isPatientLoadedAsDischarged}
                      value={dataPatient.diagnosis ? dataPatient.diagnosis : ""}
                      onChange={(e) =>
                        setDataPatient({
                          ...dataPatient,
                          diagnosis: e.target.value,
                        })
                      }
                    />
                  </Grid>

                  <Grid item xs={12} md={6}>
                    <TextField
                      data-test={"patient-add-edit-discharge-medical-history"}
                      fullWidth
                      required
                      label="Medical History"
                      size="small"
                      disabled={isPatientLoadedAsDischarged}
                      value={
                        dataPatient.medical_history
                          ? dataPatient.medical_history
                          : ""
                      }
                      onChange={(e) =>
                        setDataPatient({
                          ...dataPatient,
                          medical_history: e.target.value,
                        })
                      }
                    />
                  </Grid>

                  <Grid item xs={12} md={12}>
                    <TextField
                      data-test={"patient-add-edit-discharge-allergies"}
                      fullWidth
                      required
                      label="Allergies"
                      size="small"
                      disabled={isPatientLoadedAsDischarged}
                      value={dataPatient.allergies ? dataPatient.allergies : ""}
                      onChange={(e) =>
                        setDataPatient({
                          ...dataPatient,
                          allergies: e.target.value,
                        })
                      }
                    />
                  </Grid>

                  <Grid
                    item
                    xs={12}
                    md={12}
                    style={{ display: "flex", justifyContent: "center" }}
                  >
                    <Typography variant="caption">
                      {"Vitals (latest vitals taken at " +
                        dataPatient.news_timestamp +
                        ")"}
                    </Typography>
                  </Grid>

                  <Grid item xs={6} md={2}>
                    <TextField
                      data-test={"patient-add-edit-discharge-resp-rate"}
                      fullWidth
                      required
                      label="Respiratory Rate"
                      size="small"
                      disabled={true}
                      value={
                        dataPatient.resp_rate ? dataPatient.resp_rate : "none"
                      }
                    />
                  </Grid>

                  <Grid item xs={6} md={2}>
                    <TextField
                      data-test={"patient-add-edit-discharge-oximeter"}
                      fullWidth
                      required
                      label="Oxygen Saturation"
                      size="small"
                      disabled={true}
                      value={
                        dataPatient.oximeter ? dataPatient.oximeter : "none"
                      }
                    />
                  </Grid>

                  <Grid item xs={6} md={2}>
                    <TextField
                      data-test={"patient-add-edit-discharge-sys-dia"}
                      fullWidth
                      required
                      label="Blood Pressure"
                      size="small"
                      disabled={true}
                      value={
                        dataPatient.sys && dataPatient.dia
                          ? dataPatient.sys + "/" + dataPatient.dia
                          : "none"
                      }
                    />
                  </Grid>

                  <Grid item xs={6} md={2}>
                    <TextField
                      data-test={"patient-add-edit-discharge-hr"}
                      fullWidth
                      required
                      label="Heart Rate"
                      size="small"
                      disabled={true}
                      value={dataPatient.hr ? dataPatient.hr : "none"}
                    />
                  </Grid>

                  <Grid item xs={6} md={2}>
                    <TextField
                      data-test={"patient-add-edit-discharge-temperature"}
                      fullWidth
                      required
                      label="Temperature"
                      size="small"
                      disabled={true}
                      value={
                        dataPatient.temperature
                          ? dataPatient.temperature
                          : "none"
                      }
                    />
                  </Grid>

                  <Grid item xs={6} md={2}>
                    <TextField
                      data-test={"patient-add-edit-discharge-news-score"}
                      fullWidth
                      required
                      label="Early Warning Score"
                      size="small"
                      disabled={true}
                      value={
                        dataPatient.news_score ? dataPatient.news_score : "none"
                      }
                    />
                  </Grid>

                  <Grid item xs={12} md={6}>
                    <TextField
                      data-test={"patient-add-edit-discharge-transfer-history"}
                      fullWidth
                      required
                      label="Transfer History"
                      multiline
                      rows={2}
                      size="small"
                      disabled={isPatientLoadedAsDischarged}
                      value={
                        dataPatient.transfer_history
                          ? dataPatient.transfer_history
                          : ""
                      }
                      onChange={(e) =>
                        setDataPatient({
                          ...dataPatient,
                          transfer_history: e.target.value,
                        })
                      }
                    />
                  </Grid>

                  <Grid item xs={12} md={6}>
                    <TextField
                      data-test={
                        "patient-add-edit-discharge-medications-at-discharge"
                      }
                      fullWidth
                      required
                      label="Medications at Discharge"
                      multiline
                      rows={2}
                      size="small"
                      disabled={isPatientLoadedAsDischarged}
                      value={
                        dataPatient.medications_at_discharge
                          ? dataPatient.medications_at_discharge
                          : ""
                      }
                      onChange={(e) =>
                        setDataPatient({
                          ...dataPatient,
                          medications_at_discharge: e.target.value,
                        })
                      }
                    />
                  </Grid>

                  <Grid item xs={12} md={4}>
                    <TextField
                      data-test={
                        "patient-add-edit-discharge-prepared-by-title-position"
                      }
                      fullWidth
                      required
                      label="Prepared By Title/Position"
                      size="small"
                      disabled={isPatientLoadedAsDischarged}
                      value={
                        dataPatient.prepared_by_title_position
                          ? dataPatient.prepared_by_title_position
                          : ""
                      }
                      onChange={(e) =>
                        setDataPatient({
                          ...dataPatient,
                          prepared_by_title_position: e.target.value,
                        })
                      }
                    />
                  </Grid>

                  <Grid item xs={12} md={4}>
                    <TextField
                      data-test={"patient-add-edit-discharge-prepared-by-name"}
                      fullWidth
                      required
                      label="Prepared By Name"
                      size="small"
                      disabled={isPatientLoadedAsDischarged}
                      value={
                        dataPatient.prepared_by_name
                          ? dataPatient.prepared_by_name
                          : ""
                      }
                      onChange={(e) =>
                        setDataPatient({
                          ...dataPatient,
                          prepared_by_name: e.target.value,
                        })
                      }
                    />
                  </Grid>

                  <Grid item xs={12} md={4}>
                    <LocalizationProvider dateAdapter={AdapterMoment}>
                      <DatePicker
                        label="Discharge Date"
                        slotProps={{
                          textField: {
                            fullWidth: true,
                            required: true,
                            variant: "outlined",
                            size: "small",
                            disabled: isPatientLoadedAsDischarged,
                            "data-test": "patient-add-edit-discharge-date",
                          },
                        }}
                        disabled={dataPatient.status === 0 ? true : false}
                        format="DD/MM/YYYY"
                        dayOfWeekFormatter={(day) => `${day}`}
                        value={
                          !isNullOrEmpty(dataPatient.discharge_date)
                            ? dataPatient.discharge_date
                            : null
                        }
                        onChange={(date) =>
                          setDataPatient({
                            ...dataPatient,
                            discharge_date: moment(date).set({
                              hour: moment().hour(),
                              minute: moment().minute(),
                              second: moment().second(),
                            }),
                          })
                        }
                      />
                    </LocalizationProvider>
                  </Grid>

                  <Grid item xs={12} md={4}>
                    <TextField
                      data-test={
                        "patient-add-edit-discharge-admission-rejection"
                      }
                      select
                      fullWidth
                      required
                      label="Admission Rejection"
                      size="small"
                      disabled={isPatientLoadedAsDischarged}
                      value={dataPatient.admission_rejection}
                      onChange={(e) =>
                        setDataPatient({
                          ...dataPatient,
                          admission_rejection: Number(e.target.value),
                          admission_decline: "",
                          admission_decline_other: "",
                        })
                      }
                    >
                      <MenuItem key={1} value={1}>
                        Yes
                      </MenuItem>
                      <MenuItem key={0} value={0}>
                        No
                      </MenuItem>
                    </TextField>
                  </Grid>

                  <Grid item xs={12} md={4}>
                    {dataPatient.admission_rejection === 1 && (
                      <TextField
                        data-test={
                          "patient-add-edit-discharge-admission-decline"
                        }
                        select
                        fullWidth
                        required
                        label="Admission Decline"
                        size="small"
                        disabled={isPatientLoadedAsDischarged}
                        value={dataPatient.admission_decline}
                        onChange={(e) =>
                          setDataPatient({
                            ...dataPatient,
                            admission_decline: e.target.value,
                            admission_decline_other: "",
                          })
                        }
                      >
                        <MenuItem key={"Clinical"} value={"Clinical"}>
                          Clinical
                        </MenuItem>
                        <MenuItem key={"Psycho/Social"} value={"Psycho/Social"}>
                          Psycho/Social
                        </MenuItem>
                        <MenuItem
                          key={"Complex Discharge Requirements"}
                          value={"Complex Discharge Requirements"}
                        >
                          Complex Discharge Requirements
                        </MenuItem>
                        <MenuItem key={"Other"} value={"Other"}>
                          Other
                        </MenuItem>
                      </TextField>
                    )}
                  </Grid>

                  <Grid item xs={12} md={4}>
                    {dataPatient.admission_rejection === 1 &&
                      dataPatient.admission_decline === "Other" && (
                        <TextField
                          data-test={
                            "patient-add-edit-discharge-admission-decline-other"
                          }
                          fullWidth
                          required
                          label="Admission Decline Other"
                          size="small"
                          disabled={isPatientLoadedAsDischarged}
                          value={
                            dataPatient.admission_decline_other
                              ? dataPatient.admission_decline_other
                              : ""
                          }
                          onChange={(e) =>
                            setDataPatient({
                              ...dataPatient,
                              admission_decline_other: e.target.value,
                            })
                          }
                        />
                      )}
                  </Grid>
                </>
              )}
              <Grid
                item
                xs={12}
                md={12}
                style={{
                  display: "flex",
                  justifyContent: "flex-end",
                  flexDirection: "row",
                }}
              >
                <Button
                  data-test={"patient-add-edit-cancel-btn"}
                  id="btnCancel"
                  variant="contained"
                  color="primary"
                  style={{ marginLeft: 10 }}
                  onClick={handleClose}
                >
                  Cancel
                </Button>

                <Button
                  data-test={"patient-add-edit-save-btn"}
                  id="btnSave"
                  variant="contained"
                  color="primary"
                  style={{ marginLeft: 10 }}
                  onClick={handleSave}
                >
                  Save
                </Button>
              </Grid>
            </Grid>
          </>
        )}
      </Box>
    </Dialog>
  );
}
